<script lang="ts">
      let { item } = $props()
</script>

<div class="w-auto aspect-[2/1.7] flex items-center justify-center p-4">
      {#if item.logo}
            <!--<img src="{item.logo.url}" class="w-full h-full object-contain" >-->
            {#if item.link}
                  <a href={item.link} class="w-full h-full flex items-center justify-center">
                        {@render logo(item.logo.url)}
                  </a>
            {:else}
                  {@render logo(item.logo.url)}
            {/if}
      {/if}
      <!--<div class="h-[20%]">{item.title}</div>-->
</div>

{#snippet logo(url: string)}

<div class="logo w-full aspect-video bg-black hover:opacity-70 hover:bg-[#2a542a]" style="width: { item.sizeOverride ? `${item.sizeOverride}%`  : '100%'}; mask-image: url({item.logo.url}); mask-size: contain; mask-position: center center; mask-repeat: no-repeat"></div>
      <!--<image src={item.logo.url} class="w-full grayscale"></image>-->
{/snippet}

<style lang="postcss">
      .logo {
            transition: opacity 0.6s ease-in-out, background .6s ease-in-out;
      }
</style>
